import NBType, { InferType } from '@netbase/nb-type'
import PreviewTopicSchema from '../PreviewTopicSchema'
import EmojiCategory from '../../enums/EmojiCategory'
import ExtraInfo from '../../enums/ExtraInfo'
import DayHourTimeZone from '../../enums/DayHourTimeZone'
import GroupMetric from '../../enums/GroupMetric'
import FacetServicePropertySchema from '../FacetServicePropertySchema'

/*
 * TODO:
 * Not generated by java-to-js, so nb-type could be removed in the future and replaced with TypeScript.
 * The corresponding InsightCountOptionsVo is only used to initialize data which functionality can be handled by TypeScript as well.
 */
const InsightCountOptionsSchema = NBType.object().shape('InsightCountOptionsSchema', {
  isAuthorBased: NBType.boolean(),
  comparedTopicIds: NBType.array().of(NBType.number()),
  previewTopic: PreviewTopicSchema,
  groupInfo: NBType.boolean(),
  showPrimaryObject: NBType.boolean(),
  sizeNeeded: NBType.number(),
  multipleLevelSizeNeeded: NBType.array().of(NBType.number()),
  exactCount: NBType.number(),
  isDMA: NBType.boolean(),
  emojiCategory: NBType.enum(EmojiCategory),
  extraInfo: NBType.enum(ExtraInfo),
  postActivityTimeZone: NBType.enum(DayHourTimeZone),
  forceNotScale: NBType.boolean(),
  groupMetrics: NBType.array().of(NBType.enum(GroupMetric)),
  imageAnalysis: NBType.boolean(),
  facetServiceProperties: FacetServicePropertySchema
})

export default InsightCountOptionsSchema
export type InsightCountOptions = InferType<typeof InsightCountOptionsSchema>
// RESERVE BELOW
